// extracted by mini-css-extract-plugin
export default {"callBtn":"Nv5SQ"};